import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import * as XLSX from 'xlsx';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import { IconButton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


const API_URL = 'https://localhost:7291/api/AMCApi';
//const API_URL = 'https://pp-api.off-ease.com/api/AMCApi';

function AMCSummary() {
    const [data, setData] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { isAuthenticated, companyId } = useAuth();
    const getFirstDayOfMonth = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-01`;
    };

    const getCurrentDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    };

    useEffect(() => {
        setFromDate(getFirstDayOfMonth());
        setToDate(getCurrentDate());
    }, []);

    useEffect(() => {
        console.log('fromDate:', fromDate);
        console.log('toDate:', toDate);
        fetchData(); // Call fetchData here
    }, [fromDate, toDate]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_URL}/${fromDate}/${toDate}/${companyId}`, { mode: 'cors' });
            const responseData = response.data;

            // Check if response contains data and is not an error
            if (responseData && responseData.response_data) {
                setData(responseData.response_data);
                setError(null); // Reset error state if previous error existed
            } else {
                setError('No data available.'); // Set error message if no data found
            }
        } catch (error) {
            setError('Error fetching AMC Details. Please try again.'); // Set error message for failed request
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const refreshData = async () => {
        try {
            setLoading(true);

            // Fetch new data
            const response = await axios.get(`${API_URL}/${fromDate}/${toDate}/${companyId}`, { mode: 'cors' });

            // Check if the response is successful
            if (response.responseCode === '1111') {
                setData(response.response_data);
            } else {
                console.error('Error fetching AMC Details:', response);
            }
        } catch (error) {
            console.error('Error fetching AMC Details:', error);
        } finally {
            setLoading(false);

        }
    };


    useEffect(() => {
        refreshData();
    }, []);


    const handleRefreshClick = (e) => {
        setFromDate(getFirstDayOfMonth());
        setToDate(getCurrentDate());
        // Reload the window after state updates
        window.location.reload();
    };

    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };

    //excel

    const handleExportExcel = () => {
        const excelData = [];

        // Add header row
        const headerRow = [
            'Sl.No',
            'Customer',
            'C-Type',
            'Call-Date',
            'Category',
            'Brand',
            'Model',
            'Model Number',
            'WarrantyStatus',
            'Remarks',
            'Engineer-Name',
        ];
        excelData.push(headerRow);
        // Add data rows
        data.forEach((rowData, index) => {
            const dataRow = [
                index + 1,
                rowData.CustomerName,
                rowData.CustomerType,
                rowData.CreatedDate,
                rowData.Category,
                rowData.Brand,
                rowData.ProductModalItem,
                rowData.Modal,
                rowData.WarrantyStatus,
                rowData.Remarks,
                rowData.EngineerStaffName,

            ];
            excelData.push(dataRow);
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'AMC Report Summary');

        // Save workbook to a file
        XLSX.writeFile(wb, 'AMCSummary.xlsx');
    };

    // const handlePrint = () => {
    //     const printWindow = window.open('', '_blank');
    //     printWindow.document.write('<html><head><title>Stock Report</title></head><body>');
    //     printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">AMC SUMMARY</h3>');
    //     printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
    //     printWindow.document.write('<thead style="background-color: #f3f3f3;">');
    //     printWindow.document.write('<tr>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Customer</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">C-Type</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Call-Date</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Category</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Brand</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Modal</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Warranty</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Remarks</th>');
    //     printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Engineer</th>');

    //     printWindow.document.write('</tr>');
    //     printWindow.document.write('</thead>');
    //     printWindow.document.write('<tbody>');

    //     data.forEach((rowData, index) => {
    //         printWindow.document.write('<tr>');
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${index + 1}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CustomerName}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CustomerType}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CreatedDate && new Date(rowData.CreatedDate).toLocaleDateString('en-GB')}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Category}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Brand}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Modal}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.WarrantyStatus}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Remarks}</td>`);
    //         printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.EngineerStaffName}</td>`);

    //         printWindow.document.write('</tr>');
    //     });

    //     printWindow.document.write('</tbody></table></body></html>');
    //     printWindow.document.close();
    //     printWindow.print();
    // };
    const handlePrint = () => {
        // Opening a new window
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('Failed to open new window. Please allow pop-ups for this website.');
            return;
        }

        // Styling and HTML setup
        const style = `
            <style>
                body, table { font-family: Times New Roman; font-size: 16px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #ddd; padding: 8px; }
                th { background-color: #f3f3f3; font-size: 19px; font-weight: bold; }
                h3 { font-size: 32px; }
            </style>
        `;

        const header = '<html><head><title>AMC Report</title>' + style + '</head><body>';
        const footer = '</body></html>';

        let htmlContent = header;
        htmlContent += '<h3>AMC SUMMARY</h3><table><thead><tr>';
        const headers = ['Sl.No', 'Customer', 'C-Type', 'Call-Date', 'Category', 'Brand', 'Model', 'Model Number', 'Warranty', 'Remarks', 'Engineer'];
        headers.forEach(header => htmlContent += `<th>${header}</th>`);
        htmlContent += '</tr></thead><tbody>';

        // Adding rows
        if (Array.isArray(data)) {
            data.forEach((rowData, index) => {
                htmlContent += '<tr>';
                htmlContent += `<td>${index + 1}</td>`;
                htmlContent += `<td>${rowData.CustomerName || ''}</td>`;
                htmlContent += `<td>${rowData.CustomerType || ''}</td>`;
                htmlContent += `<td>${rowData.CreatedDate ? new Date(rowData.CreatedDate).toLocaleDateString('en-GB') : ''}</td>`;
                htmlContent += `<td>${rowData.Category || ''}</td>`;
                htmlContent += `<td>${rowData.Brand || ''}</td>`;
                htmlContent += `<td>${rowData.ProductModalItem || ''}</td>`;
                htmlContent += `<td>${rowData.Modal || ''}</td>`;
                htmlContent += `<td>${rowData.WarrantyStatus || ''}</td>`;
                htmlContent += `<td>${rowData.Remarks || ''}</td>`;
                htmlContent += `<td>${rowData.EngineerStaffName || ''}</td>`;
                htmlContent += '</tr>';
            });
        }

        htmlContent += '</tbody></table>' + footer;

        // Write to the new window and print
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.print();
    };


    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };


    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>
                        AMC CALL LIST
                    </h6>
                </div>

                <div style={{ marginBottom: '10px', marginLeft: '-20px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <Button onClick={handleExportExcel} style={{ background: '#dc3545', color: 'whitesmoke', fontWeight: 'bolder', height: '25px', marginLeft: '5px', marginTop: '25px' }} disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Excel"}
                </Button>
            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040', Width: '2500px' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Customer.</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>C-Type</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Call-Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Brand</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Model</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Model Number</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Warranty</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Remarks</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontSize: '10px', fontWeight: 'bolder', color: 'white', padding: '5px', textTransform: 'uppercase' }}>Staff</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {Array.isArray(filteredDataItem) && filteredDataItem.length > 0 ? (
                                filteredDataItem.map((item, index) => (
                                    <TableRow key={index} className="customTableRows">
                                        <TableCell sx={{ borderBottom: '1px solid #000000', padding: 2, fontSize: '13px', padding: '5px' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.CustomerName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.CustomerType}</TableCell>
                                        {/* <TableCell sx={{ fontSize: '14px' }}>{item.AllocatedDate}</TableCell> */}
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>
                                            {item.CreatedDate && new Date(item.CreatedDate).toLocaleDateString('en-GB')}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.Category}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.Brand}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.ProductModalItem}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.Modal}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.WarrantyStatus}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.Remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.EngineerStaffName}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={11} sx={{ fontSize: '16px' }}>
                                        No data available.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default AMCSummary;
